module.exports = __webpack_public_path__ + "img/bg.acca8b48.png";